//Lancamentos

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { styles } from '../styles/lancamento.mjs';
import { useClientNavigation } from '../hooks/useClientNavigation.mjs';
import { apiUrl, apiUrl2Put } from '../api/client.mjs';


const Lancamentos = () => {
    const [plataformas, setPlataformas] = useState([]);
    const [loading, setLoading] = useState(true);
    const { navigateToClient } = useClientNavigation();
    const clienteId = process.env.REACT_APP_CLIENT_ID;
    useEffect(() => {
        axios.get(apiUrl(`plataformas`))
            .then(response => {
                setPlataformas(response.data || []);
                setLoading(false);
            })
            .catch(error => {
                console.error('Erro ao buscar plataformas:', error);
                setLoading(false);
            });
    }, [clienteId]);

    const handleAddClick = () => navigateToClient('/form');
    const handleEditClick = (id) => navigateToClient(`/form/${id}`);
    const handleDelete = (id) => {
        axios.delete(apiUrl2Put(id))
            .then(() => setPlataformas(prev => prev.filter(p => p.id !== id)))
            .catch(error => console.log("Delete failed: " + error.message));
    };

    if (loading) {
        return <p>Loading...</p>;
    }

    return (
        <div style={styles.container}>
            <h2 style={styles.titulo}>Configure seus Lançamentos</h2>
            <p style={styles.descricao}>Cadastre, edite ou exclua seus lançamentos.</p>
            <button onClick={handleAddClick} style={styles.botaoAdicionar}>Adicionar Lançamento</button>
            <ul style={styles.listaPlataformas}>
                {plataformas.length > 0 ? plataformas.map((plataforma) => (
                    <li key={plataforma.plataforma_id} style={styles.itemPlataforma}>
                        <span>{plataforma.plataforma_nome}</span>
                        <div>
                            <button onClick={() => handleEditClick(plataforma.plataforma_id)} style={styles.botaoAcao}>Editar</button>
                            <button onClick={() => handleDelete(plataforma.plataforma_id)} style={styles.botaoAcao}>Excluir</button>
                        </div>
                    </li>
                )) : <p>Nenhuma plataforma encontrada.</p>}
            </ul>
        </div>
    );
};

export default Lancamentos;
